class ProductStickyBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.lastKnownTop = false
    this.setupObservers()
  }

  setupObservers () {
    this.onDesktopEntry = this.onDesktopEntry.bind(this)
    this.onMobileEntry = this.onMobileEntry.bind(this)

    const config = {
      threshold: 0,
    }

    this.desktopObserver = new IntersectionObserver(
      this.onDesktopEntry,
      config,
    )
    this.mobileObserver = new IntersectionObserver(this.onMobileEntry, config)

    this.desktopObserver.observe(this.externalEls.desktopObserve.element)
    this.mobileObserver.observe(this.externalEls.mobileObserve.element)
  }

  onDesktopEntry ([entry]) {
    this.onEntry(entry, true)
  }

  onMobileEntry ([entry]) {
    this.onEntry(entry, false)
  }

  onEntry (entry, desktop) {
    if (window.BAO.MediaBreakpoints.isMd && !desktop) return
    if (!window.BAO.MediaBreakpoints.isMd && desktop) return

    const elPosition = entry.boundingClientRect
    const elTop = elPosition.top

    const show = desktop
      ? (entry.isIntersecting && elTop > 0) ||
        (!entry.isIntersecting && elTop < 0)
      : !entry.isIntersecting && elTop < 0

    if (!show && elTop < window.innerHeight && desktop) return

    this.toggleSticky(show)
  }

  toggleSticky (show) {
    this.classList.toggle('prd-StickyBar-active', show)
  }
}

if (!customElements.get('product-sticky-bar')) {
  customElements.define('product-sticky-bar', ProductStickyBar)
}
